<!-- <div class="row"> -->
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo bene'"
	[valueInput]="element.tipoBeneMobile.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'importo'"
	[labelInput]="'Valore del bene'"
	[valueInput]="element.valore? element.valore: ''"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
	[labelInput]="'Ipoteca'" [valueInput]="element.ipoteca"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'importo'"
	[labelInput]="'Valore del bene'"
	[valueInput]="element.valoreIpoteca? element.valoreIpoteca: ''"></div>
<!-- </div> -->